
import React from "react";
import DataTable from "react-data-table-component";
import { Download, FileText } from "react-feather";
import { exportToExcel, exportToPDF } from "../../utils/downloadExportedFiles";

const DataTableExport = ({ title, columns, data }) => {
  const isDisabled = !data || data.length === 0;

  const customStyles = {
    headCells: {
      style: {
        fontWeight: "bold",
        backgroundColor: "#f8f9fa",
      },
    },
  };

  return (
    <div className="card shadow-sm border-0">
      <div className="card-header d-flex justify-content-between align-items-center bg-white">
        <h5 className="mb-0">{title}</h5>
        <div>
          <button
            className="btn btn-sm btn-outline-success me-2"
            onClick={() => exportToExcel(title, columns, data)}
            title="Export to Excel"
            disabled={isDisabled}
          >
            <Download size={16} className="me-1" /> Excel
          </button>
          <button
            className="btn btn-sm btn-outline-danger"
            onClick={() => exportToPDF(title, columns, data)}
            title="Export to PDF"
            disabled={isDisabled}
          >
            <FileText size={16} className="me-1" /> PDF
          </button>
        </div>
      </div>

      <div className="card-body">
        <DataTable
          columns={columns}
          data={data}
          pagination
          paginationPerPage={20}   // ✅ default rows per page
          paginationRowsPerPageOptions={[10, 20, 50, 100, 200]}  // optional
          highlightOnHover
          customStyles={customStyles}
          responsive
          dense
        />
      </div>
    </div>
  );
};

export default DataTableExport;
